import { generateActions } from "../utils";

export const GET_LANDING_DATA = generateActions("GET_LANDING_DATA");
